<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="order" />
    <pcUserNavComponent tabBarKey="order">
      <div class="page-container">
        <div class="page-title-item">
          <div class="title-item active">我的订单</div>
        </div>
        <div class="search-item">
          <div class="status-list-item"> 
            <div class="item" :class="status === 0 ? 'active' : ''" @click="handleChangeStatus(0)">全部</div>
            <div class="item" :class="status === 8 ? 'active' : ''" @click="handleChangeStatus(8)">待处理</div>
            <div class="item" :class="status === 2 ? 'active' : ''" @click="handleChangeStatus(2)">进行中</div>
            <div class="item" :class="status === 4 ? 'active' : ''" @click="handleChangeStatus(4)">已完成</div>
            <div class="item" :class="status === 7 ? 'active' : ''" @click="handleChangeStatus(7)">已退款</div>
            <div class="item" :class="status === 3 ? 'active' : ''" @click="handleChangeStatus(3)">异常中</div>
          </div>
          <div class="input-item">
            <div class="input"><input v-model="orderNoSearchKey" type="text" placeholder="请输入你的订单号"  /></div>
            <div class="input"><input v-model="buyParamsSearchKey" type="text" placeholder="请输入下单参数"  /></div>
            <div class="btn" @click="handleSearch"><img src="../../assets/pc-images/search-icon.png" class="icon" /></div>
          </div>
        </div>
        <div v-if="finish && orderList.length == 0" class="empty-item" style="padding: 50px 0;">
          <div class="icon img-cover"><img src="../../assets/pc-images/empty-icon.png" /></div>
        </div>
        <div v-else class="order-list-item">
          <div class="order-item" v-for="(item, index) in orderList" :key="index" @click="handleToDetail(item)">
            <div class="order-header-item">
              <div class="item"><span>订单号: {{ item.Id }}</span><img class="btn" @click.stop="handleCopy(`${item.Id}`)" src="../../assets/pc-images/copy-blue-icon.png" /></div>
              <div class="item"><span>时间: {{ $TOOL.dateFormat(item.CreateAt * 1000, 'yyyy-MM-dd hh:mm') }}</span></div>
              <div class="item" v-if="item.BuyParams && item.BuyParams.length > 0"><span>{{ item.BuyParams[0].name }}: {{ item.BuyParams[0].value }}</span> <img class="btn" @click.stop="handleCopy(`${item.BuyParams[0].value}`)" src="../../assets/pc-images/copy-blue-icon.png" /></div>
              <div class="flex-1"></div>
              <div class="status" :class="'status-' + ([-1,1,2].includes(item.OrderStatus) ? 'green' : item.OrderStatus == 4 ? 'blue' : 'gray')">
                <img class="icon" src="../../assets/pc-images/status-icon.png" />
                <img class="black-icon" src="../../assets/pc-images/status-black-icon.png" />
                {{ orderStatusObj[item.OrderStatus] }}
              </div>
            </div>
            <div class="goods-info-item">
              <div class="img img-cover">
                <img v-if="item.Img" :src="item.Img" />
                <img v-else src="../../assets/images/no-image-icon.png" />
              </div>
              <div class="info-item">
                <div class="name-info-item">
                  <div class="name-item">{{ item.GoodsName }} ¥ {{ Math.round(item.SellingPrice * 100000) / 100000 }}</div>
                  <div class="money-item">实付款 <span>¥ {{ Math.round(item.Amount * 100000) / 100000 }}</span></div>
                </div>
                <div class="detail-item">
                  <div class="count-item">
                    <span>开始 {{ item.StartNum }}</span>·
                    <span>当前 {{ item.CurrentNum }}</span>·
                    <span>完成 {{ item.CurrentNum - item.StartNum }}</span>
                  </div>
                  <div class="btn-list-item" @click.stop="()=>{}">
                    <router-link :to="{ path: '/content', query: {order_id: item.Id, pageType: 2, page: 'add'} }" class="btn"><img src="../../assets/pc-images/order-gd-icon.png" class="icon"/>工单售后</router-link>
                    <div class="btn" @click="handleToDetail(item)"><img src="../../assets/pc-images/order-view-icon.png" class="icon"/>查看详情</div>
                    <router-link :to="{ path: '/goodsDetail', query: {id: item.GoodsId} }" class="btn"><img src="../../assets/pc-images/order-buy-icon.png" class="icon"/>再次下单</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!finish && orderList.length > 0" class="more-goods-btn" @click="getOrderList">
            <van-loading v-if="loading" size="20" color="#5783fc" />
            <span v-else>查看更多</span>
          </div>
        </div>
      </div>
    </pcUserNavComponent>
    <orderDetailComponent v-if="dialog.detail" ref="orderDetailDialog" @close="dialog.detail = false" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'
import orderDetailComponent from './OrderDetailComponent';

export default {
  name: "Order",
  components: {
    pcTabBarComponent,
    pcUserNavComponent,
    orderDetailComponent
  },
  data() {
    return {
      dialog: {
        detail: false
      },
      orderNoSearchKey: '',
      buyParamsSearchKey: '',
      orderNo: '',
      buyParams: '',
      status: 0,
      page: 1,
      pageCount: 10,
      loading: false,
      finish: false,
      orderList: [],
      orderStatusObj: { '-1': '待付款', '1': '已付款', '2': '处理中', '3': '异常', '4': '已完成', '5': '退单中', '6': '已退单', '7': '已退款', '8': '待处理' },
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    handleToDetail(item) {
      this.dialog.detail = true
      this.$nextTick(() => {
        this.$refs.orderDetailDialog.open(item.Id)
      })
    },
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    handleChangeStatus(status) {
      this.status = status
      this.page = 1
      this.finish = false
      this.loading = false
      this.orderList = []
      this.getOrderList()
    },
    handleSearch() {
      this.orderNo = this.orderNoSearchKey
      this.buyParams = this.buyParamsSearchKey
      this.page = 1
      this.finish = false
      this.loading = false
      this.orderList = []
      this.getOrderList()
    },
    async getOrderList() {
      const { pageCount, page, orderList, orderNo, buyParams, status, loading, finish } = this
      if (loading || finish) {
        return
      }
      const params = {
        PageCount: pageCount, 
        Page: page
      }
      if (status) {
        params.Status = status
      }
      if (orderNo) {
        params.OrderSN = orderNo
      }
      if (buyParams) {
        params.BuyParams = buyParams
      }
      this.loading = true
      var res = await this.$API.orderList.post(params)
      const data = []
      for (let index = 0; index < res.info.length; index++) {
        const item = res.info[index]
        data.push({
          ...item,
          CanTui: item.CanTui.split(','),
          BuyParams: JSON.parse(item.BuyParams)
        })
      }
      if (page == 1) {
        this.orderList = [
          ...data
        ]
      } else {
        this.orderList = [
          ...orderList,
          ...data
        ]
      }
      this.page = page + 1
      this.finish = data.length < pageCount
      this.loading = false
    },
  },
}

</script>

<style lang="less" scoped>
.page-container {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px;
  overflow: hidden;
}
.page-title-item {
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  .title-item {
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
.search-item {
  padding: 20px 0;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  .status-list-item {
    display: flex;
    align-items: center;
    .item {
      padding: 0 12px;
      height: 25px;
      border-radius: 13px;
      background-color: #f5f7fa;
      line-height: 25px;
      color: #64748b;
      font-size: 12px;
      margin-right: 10px;
      cursor: pointer;
      &:nth-last-child(1) {
        margin-right: 0;
      }
      &.active {
        background-color: #5783fc;
        color: #fff;
      }
    }
  }
  .input-item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    display: flex;
    align-items: center;
    .input {
      width: 208px;
      height: 33px;
      margin-right: 10px;
      padding: 0 10px 0 14px;
      height: 25px;
      border: 1px solid #e5e5e5;
      border-radius: 18px;
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 25px;
      border-radius: 13px;
      background-color: #5783fc;
      margin-right: 10px;
      cursor: pointer;
      .icon {
        width: 12px;
        height: 12px;
      }
    }
  }
}
.order-list-item {
  padding: 0 5px;
  overflow: hidden;
  .order-item {
    cursor: pointer;
    border-top: 1px solid #e5e5e5;
    padding: 14px;
    .order-header-item {
      display: flex;
      align-items: center;
      height: 20px;
      line-height: 20px;
      .item {
        display: flex;
        align-items: center;
        font-size: 10px;
        color: #64748b;
        margin-right: 25px;
        span {
          max-width: 150px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .btn {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }
      .status {
        padding: 0 6px;
        border-radius: 5px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        &.status-green {
          background-color: #52ad3c;
          color: #fff;
        }
        &.status-blue {
          background-color: #5783fc;
          color: #fff;
        }
        &.status-gray {
          background-color: #e5e5e5;
          color: #383838;
          .icon {
            display: none;
          }
          .black-icon {
            display: block;
          }
        }
        .icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
        .black-icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
          display: none;
        }
      }
    }
    .goods-info-item {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .img {
        width: 55px;
        height: 55px;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 13px;
      }
      .info-item {
        flex: 1;
        .name-info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 22px;
          color: #393942;
          font-weight: 500;
          .name-item {
            flex: 1;
            margin-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .money-item {
            span {
              color: #d43030;
              font-size: 18px;
            }
          }
        }
        .detail-item {
          margin-top: 6px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .count-item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            height: 20px;
            border-radius: 2px;
            background-color: #f6ffed;
            font-size: 10px;
            color: #52ad3c;
          }
          .btn-list-item {
            display: flex;
            align-items: center;
            .btn {
              display: flex;
              align-items: center;
              font-size: 10px;
              color: #5783fc;
              margin-left: 20px;
              cursor: pointer;
              .icon {
                margin-right: 5px;
                width: 10px;
                height: 10px;
              }
            }
          }
        }
      }
    }
  }
}
.more-goods-btn {
  margin: 20px auto 50px;
  width: 75px;
  height: 25px;
  border: 1px solid #5783fc;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5783fc;
  font-weight: 500;
  cursor: pointer;
}
</style>